// Property Detail
export const PROPERTY_TAB_HASH = 'property'
export const MEMBERSHIPS_TAB_HASH = 'memberships'
export const EVENT_LOG_TAB_HASH = 'eventLog'
export const AUDIT_LOG_TAB_HASH = 'auditLog'
export const INSTALLATIONS_TAB_HASH = 'installations'
export const INTEGRATIONS_TAB_HASH = 'integrations'
export const PERFORMANCE_TAB_HASH = 'performance'
export const CONNECTIVITY_MAP_TAB_HASH = 'connectivityMap'

// Property Detail -> Property Tab
export const PROPERTY_TAB_UNITS_HASH = 'units'
export const PROPERTY_TAB_THRESHOLDS_HASH = 'thresholds'
export const PROPERTY_TAB_DEVICES_HASH = 'devices'
export const PROPERTY_TAB_RESERVATIONS_HASH = 'reservations'
export const PROPERTY_TAB_ISSUES_HASH = 'issues'
export const PROPERTY_TAB_INVOICES_HASH = 'invoices'
export const PROPERTY_TAB_CONTRACTS_HASH = 'contracts'
export const PROPERTY_TAB_REVIEWS_HASH = 'reviews'
